import { render, staticRenderFns } from "./ApproveAreaPromoterCRM.vue?vue&type=template&id=5fc8db8a&scoped=true"
import script from "./ApproveAreaPromoterCRM.vue?vue&type=script&lang=js"
export * from "./ApproveAreaPromoterCRM.vue?vue&type=script&lang=js"
import style0 from "./ApproveAreaPromoterCRM.vue?vue&type=style&index=0&id=5fc8db8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8db8a",
  null
  
)

export default component.exports